<template>
  <v-container fluid class="pa-0">
    <v-layout row>
      <v-layout v-if="reportsPending">
        <v-flex grow>
          Getting Currently-Working records...
          <v-progress-linear indeterminate></v-progress-linear>
        </v-flex>
      </v-layout>

      <v-layout v-else column>
        <v-card>
          <v-card-title>
            <v-layout column>
              <v-layout row>
                <h2 class="display-1">Currently clocked-in</h2>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-layout>
            </v-layout>
          </v-card-title>

          <v-data-table
            ref="shiftsTable"
            :headers="headers"
             :items="shiftsFiltered"
             item-key="id"
             :search="search"
             :pagination.sync="defaultSort"
             class="elevation-1"
          >
            <template slot="items" slot-scope="{ item }">
              <tr @click="expand(item)">
                <td>
                  {{ item.startDatetime | moment("dddd MMMM D, YYYY") }}
                  <router-link
                    :to="{ name: 'shiftDetail', params: { shiftId: item.id } }"
                    target="_blank"
                  >
                  <v-icon small>open_in_new</v-icon>
                  </router-link>
                </td>
                <td>{{ item.locationName }}</td>
                <td>{{ item.workerName }}</td>
                <td>{{ item.positionWorked }}</td>
                <td>
                  <span>{{ item.startDatetime | moment("h:mma") }}</span> / 
                  <span :class="startPunchClass(item)">
                    <template v-if="startPunchFrom(item)">
                      {{ startPunchFrom(item).punch_time | moment("h:mma") }}
                    </template>
                    <template v-else>
                      N/A
                    </template>
                  </span>
                </td>
                <td>
                  <span>{{ item.endDatetime | moment("h:mma") }}</span> / 
                  <span :class="endPunchClass(item)">
                    <template v-if="endPunchFrom(item)">
                      {{ endPunchFrom(item).punch_time | moment("h:mma") }}
                    </template>
                    <template v-else>
                      <v-icon v-if="item.hoursWorked > 12">timelapse</v-icon>
                      <span v-else>
                        NA
                      </span>
                    </template>
                  </span>
                </td>
                <td>
                  <span v-if="item.hoursWorked > 12" class="red--text">{{ item.hoursWorked }}</span>
                  <span v-else>{{ item.hoursWorked }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-layout>
      <v-dialog v-model="isShiftExpanded" v-if="isShiftExpanded">
        <v-card v-if="!havePunches">
          <v-card-text>
            <v-progress-linear indeterminate></v-progress-linear>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-text>
            <v-layout justify-end column class="text-xs-right mb-3">
              <v-layout row justify-space-between>
                <h2 class="subheading mb-2">Timecard entries for <span class="font-weight-bold">{{ shiftExpanded.workerName }}</span> as {{ shiftExpanded.positionWorked }} starting on <span class="font-weight-bold">{{ shiftExpanded.startDatetime | moment("dddd MMMM D, YYYY") }}</span></h2>
                <v-flex class="mb-4">
                  <v-icon @click="isShiftExpanded = false">close</v-icon>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout column>
              <v-flex class="mb-4">
                <div>
                  <ul>
                  <li v-if="shiftExpanded.straightBonus">
                    {{ shiftExpanded.straightBonusAmount }}
                    <v-icon small v-if="shiftExpanded.straightBonus">local_atm</v-icon>
                    Straight Bonus
                  </li>
                  <li v-if="shiftExpanded.callInBonus">
                    {{ shiftExpanded.callInBonusAmount }}
                    <v-icon small v-if="shiftExpanded.callInBonus">phone</v-icon>
                    Call-in Bonus
                  </li>
                  <li v-if="shiftExpanded.travelBonus">
                    {{ shiftExpanded.travelBonusAmount }}
                    <v-icon small v-if="shiftExpanded.travelBonus">directions_car</v-icon>
                    Travel Bonus
                  </li>
                  </ul>
                </div>
              </v-flex>
              <v-flex class="mb-4">
                <div>
                  <div v-if="shiftExpanded.employeeNotes">
                    Employee's Notes: {{ shiftExpanded.employeeNotes }}
                  </div>
                  <div v-if="shiftExpanded.clientNotes">
                    Clients's Notes: {{ shiftExpanded.clientNotes }}
                  </div>
                </div>
              </v-flex>
                <ApiField
                  v-if="user.bohOrHigher || user.clientAdmin"
                  fieldType="switch"
                  label="Employee was absent"
                  storeAction="shifts/update"
                  storeUpdate="shifts/updateViewedShift"
                  paramName="shift"
                  :object="shiftExpanded"
                  fieldName="employee_absent"
                  :storeFieldValue="shiftExpanded.employeeAbsent"
                >
                </ApiField>
              <v-layout v-if="!sortedPunches || sortedPunches.length < 1">
                <h2 class="subheading text-xs-center">No timeclock entries!</h2>
              </v-layout>
              <v-layout v-else row>
                <v-flex grow>
                  <table style="width: 100%;">
                    <thead>
                      <tr>
                        <th class="text-xs-left">Edit</th>
                        <th class="text-xs-left">Type</th>
                        <th class="text-xs-left">Date</th>
                        <th class="text-xs-left">Time</th>
                        <th class="text-xs-right">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <PunchRow
                        :punch="punch"
                        v-for="punch in sortedPunches"
                        :key="punch.id"
                        :editable="user.bohOrHigher"
                      >
                      </PunchRow>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
              <v-layout v-if="user.bohOrHigher" row class="mt-4 text-xs-right">
                <v-flex>
                  <v-btn class="no-margin" :loading="timeclockCreatePending" :disabled="timeclockCreatePending" @click="createManagerClockEntry" color="success">
                    <v-icon left>
                      add
                    </v-icon>
                    Timeclock entry
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import ApiField from '@/components/base/api-field.vue'
import { mapState, mapGetters } from 'vuex'
import PunchRow from '@/components/calendar/punch.vue'
import { ExportToCsv } from 'export-to-csv';

export default {
  components: {
    PunchRow,
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapGetters('timeclock', [
      'sortedPunches',
    ]),
    shiftsFiltered: function () {
      var filtered = this.shifts

      if (this.hideUnassigned) {
        filtered = filtered.filter(s => s.workerId)
      }

      if (this.hideUnclockedIn) {
        filtered = filtered.filter(s => {
          if (s.punches.find(p => (p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideClockedIn) {
        filtered = filtered.filter(s => {
          if (!s.punches.find(p => (p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideClockedOut) {
        filtered = filtered.filter(s => {
          if (!s.punches.find(p => (!p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideWithoutClockedOut) {
        filtered = filtered.filter(s => {
          if (s.punches.find(p => (!p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideUnabsent) {
        filtered = filtered.filter(s => {
          if (s.employeeAbsent) {
            return s
          }
        })
      }

      // if (this.onlyShowMissingClockouts) {
      //   filtered = this.shifts.filter(s => {
      //     if (!s.punches.find(p => (!p.start && p.endcap))) {
      //       return s
      //     }
      //   })
      // }

      return filtered
    },
  },
  created () {
    this.getReports()
  },
  watch: {
    'isShiftExpanded' : {
      handler(open) {
        this.closeExpansion(open)
      }
    },
    'advancedOptions' : {
      handler(checked) {
        if (!checked) {
          this.resetFilters()
        }
      }
    },
  },
  data: function () {
    return {
      timeclockCreatePending: false,
      isShiftExpanded: false,
      shiftExpanded: null,
      havePunches: true,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(3, "weeks").format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),
      haveDates: false,
      reportsPending: true,
      shifts: [],
      search: '',
      advancedOptions: false,
      hideUnassigned: false,
      hideUnclockedIn: false,
      hideClockedIn: false,
      hideClockedOut: false,
      hideWithoutClockedOut: false,
      hideUnabsent: false,
      defaultSort: {
        sortBy: 'startDatetime',
        ascending: true,
        rowsPerPage: 15,
      },
      headers: [
        { text: 'Date', value: 'startDatetime' },
        { text: 'Location Name', sortable: true, value: 'locationName' },
        { text: 'Employee Name', sortable: false, value: 'workerName' },
        { text: 'Position Worked', value: 'positionWorked' },
        { text: 'Scheduled Start / Clocked in', sortable: false, value: 'startDatetime' },
        { text: 'Scheduled End / Clocked out', sortable: false},
        { text: 'Hours worked', sortable: true, value: 'hoursWorked' }
      ],
    }
  },

  methods: {
    // filterOpenShifts: function (hoursWorked) {
    //   return hoursWorked > 12
    // },
    resetFilters: function () {
      this.hideUnassigned = false
      this.hideUnclockedIn = false
      this.hideClockedIn = false
      this.hideClockedOut = false
      this.hideWithoutClockedOut = false
    },
    startPunchFrom: function (shift) {
      return shift.punches.find(p => {
        return (p.start && p.endcap)
      })
    },
    startPunchClass: function (shift) {
      var classList = []
      if (!this.startPunchFrom(shift)) {
        classList.push('grey--text')
      } else {
        classList.push('font-weight-bold')
        const clockInTime = this.startPunchFrom(shift).punch_time
        const scheduledInTime = shift.startDatetime
        const diff = this.$moment(clockInTime).diff(this.$moment(scheduledInTime), 'minutes')
        if (Math.abs(diff) > 15) {
          classList.push('red--text')
        }
      }
      return classList
    },
    endPunchFrom: function (shift) {
      return shift.punches.find(p => {
        return (!p.start && p.endcap)
      })
    },
    endPunchClass: function (shift) {
      var classList = []
      if (!this.endPunchFrom(shift)) {
        classList.push('grey--text')
      } else {
        classList.push('font-weight-bold')
        const clockInTime = this.endPunchFrom(shift).punch_time
        const scheduledInTime = shift.endDatetime
        const diff = this.$moment(clockInTime).diff(this.$moment(scheduledInTime), 'minutes')
        if (Math.abs(diff) > 15) {
          classList.push('red--text')
        }
      }
      return classList
    },
    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },
    getReports () {
      this.$store.dispatch('reports/getCurrentlyWorking')
      .then(shifts => {
        this.shifts = shifts.shifts
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.reportsPending = false
      })
    },
    expand: function(shift) {
      if (!shift.workerName) {
        return
      }
      this.isShiftExpanded = true
      this.shiftExpanded = shift
      this.havePunches = false
      this.$store.dispatch('timeclock/getPunches', { shiftId: shift.id })
      .finally(res => {
        this.havePunches = true
      })
    },
    closeExpansion: function (open) {
      if (!open) {
        this.shiftExpanded = null
        this.isShiftExpanded = false
        // TODO: maybe update something or other based on changes made in modal?
      }
    },
    createManagerClockEntry () {
      this.timeclockCreatePending = true
      this.$store.dispatch('timeclock/managerCreate', this.shiftExpanded.id)
      .then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Timeclock entry created! Be sure to update it." })
      })
      .catch(err => {
        this.$store.dispatch('global/showSnackbarError', { message: "There was a problem creating a timeclock entry" })
      })
      .finally(res => {
        this.timeclockCreatePending = false
      })
    },
  },
}
</script>

<style scoped>
</style>
